export default __webpack_public_path__ + "static/media/Large-cap-nfo-small-banner.1a5e5b88.png";